import { render, staticRenderFns } from "./OnFssDetail.vue?vue&type=template&id=5fb85818&"
import script from "./OnFssDetail.vue?vue&type=script&lang=js&"
export * from "./OnFssDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports